"use client";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { getComponentMenuUpdateHint } from "@/lib/docs/menu/component-updates";

export function ComponentUpdateIndicator({ category }: { category: string }) {
  const hint = getComponentMenuUpdateHint(category);

  if (!hint) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <span className="inline-flex shrink-0 cursor-help">
            <span className="sr-only">{hint}</span>
            <span
              aria-hidden="true"
              className="site-rounded-md size-2 animate-badge-pop bg-blue-500 motion-reduce:animate-none"
            />
          </span>
        }
      />
      <TooltipContent side="right" sideOffset={8}>
        {hint}
      </TooltipContent>
    </Tooltip>
  );
}
